import AllCurrencies from "./components/AllCurrencies";
import CurrencyConverter from "./components/CurrencyConverter";

function App() {
	return (
		<div className="bg-light py-4">
			<div className="container">
				<CurrencyConverter />
				<AllCurrencies />
			</div>
		</div>
	);
}

export default App;
